export const UNIT_MEASURE_CAPACITY_TYPES = [
  {code: '', value: null},
  {code: 'gal', value: 'Gallons'},
  {code: 'g/d', value: 'Gallons per Day'},
  {code: 'g/m', value: 'Gallons per Minute'}
];
